module.exports = __webpack_public_path__ + "img/Ellipse2.5573f473.svg";